import { render, staticRenderFns } from "./AddEditTagModal.vue?vue&type=template&id=ad408778&scoped=true"
import script from "./AddEditTagModal.vue?vue&type=script&lang=js"
export * from "./AddEditTagModal.vue?vue&type=script&lang=js"
import style0 from "./AddEditTagModal.vue?vue&type=style&index=0&id=ad408778&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad408778",
  null
  
)

export default component.exports